import type { ListCardsQuery } from '../../__generated__/graphql/api';

type ListCardsResultCards = NonNullable<NonNullable<ListCardsQuery['listCards']>['cards']>;

type ListCardsResultCard = NonNullable<ListCardsResultCards[number]>;

export interface CardListItem {
  id: string;
  status: string | null;
  referenceId: string | null;
  active: boolean | null;
  insertedAt: string | null;
  userId: string | null;
  userDisplayName: string | null;
  userIsFriendsAndFam: boolean | null;
  programName: string | null;
}

const buildUserDisplayName = (firstName: string | null | undefined, lastName: string | null | undefined) => {
  const name = [firstName, lastName].filter(Boolean).join(' ').trim();

  return name || null;
};

export const toCardListItem = (card: ListCardsResultCard): CardListItem => ({
  id: card.id ?? '',
  status: card.status ?? null,
  referenceId: card.referenceId ?? null,
  active: card.active ?? null,
  insertedAt: card.insertedAt ?? null,
  userId: card.user?.id ?? null,
  userDisplayName: buildUserDisplayName(card.user?.firstName, card.user?.lastName),
  userIsFriendsAndFam: card.user?.isFriendsAndFam ?? null,
  programName: card.loan?.program?.name ?? null,
});
